import {
  PlateEditor,
  Value,
  wrapNodes,
  WrapNodesOptions,
} from '@udecode/plate-common';

import { ELEMENT_ANCHOR_LINK, MyAnchorLinkElement } from '../../../plateTypes';

export interface WrapElementLinkOptions<
  V extends Value = Value,
> extends WrapNodesOptions<V> {
  linkId: string;
}

/** Wrap a link node with split. */
export const wrapAnchorLink = <V extends Value>(
  editor: PlateEditor<V>,
  { linkId, ...options }: WrapElementLinkOptions<V>,
): void => {
  wrapNodes<MyAnchorLinkElement, Value>(
    editor,
    {
      type: ELEMENT_ANCHOR_LINK,
      linkId,
      children: [],
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    { split: true, ...options } as any,
  );
};
